import React from 'react';
// import { OpenRepLogo } from 'loghi';
import { OETrans } from 'components/translation/OETrans';
import { SonarLogo } from '@loghi/index';
import NewBrandBanner from '@components/NewBrand/NewBrandBanner';

const LoginHero = () => {
	const styleHighlight = {
		fontWeight: 700,
	};

	return (
		<div
			className="d-none d-lg-flex"
			style={{
				backgroundColor: 'var(--np-secondary-color--light)',
				display: 'flex',
				alignItems: 'center',
				padding: '1rem',
			}}
		>
			<div
				className="flex-column justify-content-center"
				style={{
					maxWidth: '632px',
					margin: '0 auto',
				}}
			>
				<div
					className="d-flex justify-content-center align-items-center"
					style={{
						flexDirection: 'column',
						gap: '7.5rem',
					}}
				>
					<NewBrandBanner />
					{/* <OpenRepLogo width="250" /> */}
					<SonarLogo
						style={{
							fill: 'var(--np-text-primary-color)',
						}}
					/>
				</div>
				<h1
					className="mt-5"
					style={{
						fontSize: '24px',
						fontWeight: 700,
						textAlign: 'center',
						// lineHeight: '57.6px',
						// fontFamily: 'Barlow',
					}}
				>
					<OETrans code="common.hero.header1" fallback={'La soluzione integrata per la'} />
					&nbsp;
					<OETrans code="common.hero.header2" fallback={'governance dei contributi'} />
					&nbsp;
					<OETrans code="common.hero.header3" fallback={'pubblici'} />
				</h1>
				<p
					className="pt-4"
					style={{
						fontSize: '18px',
						textAlign: 'center',
						// fontWeight: '300',
						// lineHeight: '43.2px',
						// fontFamily: 'Barlow',
					}}
				>
					<OETrans code="common.hero.text1" fallback={'Gestisci la rendicontazione in maniera'} />
					&nbsp;
					<span style={styleHighlight}>
						<OETrans code="common.hero.text2" fallback={'efficace'} />
					</span>
					&nbsp;
					<OETrans code="common.hero.text3" fallback={'e'} />
					&nbsp;
					<span style={styleHighlight}>
						<OETrans code="common.hero.text4" fallback={'sicura'} />
					</span>
					,&nbsp;
					<OETrans code="common.hero.text5" fallback={'in ottemperanza agli'} />
					&nbsp;
					<OETrans code="common.hero.text6" fallback={'obblighi normativi e ai prescritti'} />
					&nbsp;
					<OETrans code="common.hero.text7" fallback={'specifici delle misure'} />.
				</p>
			</div>
		</div>
	);
};

export default LoginHero;
